import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {isApplicationAbroad} from "../../utils/form/is_application_abroad";

interface IProps {
    storeHash: string;
}

/**
 * @depracated use useRecommendations hook instead
 */
export const useMultiLeadData = (props: IProps) => {
    const isAuthenticated = useIsAuthenticated();

    const applicationData = useSelector((store: IRPStore) => store.application[props.storeHash]);
    const viewType = useSelector((store: IRPStore) => store.viewType.current);
    const originalApplicationGeoPoint = useSelector((store: IRPStore) => store.application[props.storeHash]?.offer?.detail?.geo_point);
    const originalApplicationRegionCityID = useSelector(
        (store: IRPStore) => store.application[props.storeHash]?.offer?.detail?.region?.stats?.region_type_city?.id
    );
    const originalApplicationCountry = useSelector((store: IRPStore) => store.application[props.storeHash]?.offer?.detail?.region.country);

    return {
        applicationData,
        isAuthenticated,
        viewType,
        originalApplicationGeoPoint,
        originalApplicationRegionCityID,
        originalApplicationCountry,
        isAbroadLead: isApplicationAbroad(originalApplicationCountry)
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {isApplicationAbroad} from "../../utils/form/is_application_abroad";

interface IProps {
    storeHash: string;
}

/**
 * @depracated use useRecommendations hook instead
 */
export const useMultiLeadData = (props: IProps) => {
    const isAuthenticated = useIsAuthenticated();

    const applicationData = useSelector((store: IRPStore) => store.application[props.storeHash]);
    const viewType = useSelector((store: IRPStore) => store.viewType.current);
    const originalApplicationGeoPoint = useSelector((store: IRPStore) => store.application[props.storeHash]?.offer?.detail?.geo_point);
    const originalApplicationRegionCityID = useSelector(
        (store: IRPStore) => store.application[props.storeHash]?.offer?.detail?.region?.stats?.region_type_city?.id
    );
    const originalApplicationCountry = useSelector((store: IRPStore) => store.application[props.storeHash]?.offer?.detail?.region.country);

    return {
        applicationData,
        isAuthenticated,
        viewType,
        originalApplicationGeoPoint,
        originalApplicationRegionCityID,
        originalApplicationCountry,
        isAbroadLead: isApplicationAbroad(originalApplicationCountry)
    };
};
